import { render, staticRenderFns } from "./BulkDeleteCollectionsModal.vue?vue&type=template&id=9ea15612&"
import script from "./BulkDeleteCollectionsModal.vue?vue&type=script&lang=js&"
export * from "./BulkDeleteCollectionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports